import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=7d2fa868&"
import script from "./NotificationMessage.vue?vue&type=script&lang=js&"
export * from "./NotificationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d2fa868')) {
      api.createRecord('7d2fa868', component.options)
    } else {
      api.reload('7d2fa868', component.options)
    }
    module.hot.accept("./NotificationMessage.vue?vue&type=template&id=7d2fa868&", function () {
      api.rerender('7d2fa868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/NotificationMessage.vue"
export default component.exports